import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, message, Tag, Tooltip, Spin } from 'antd';
import { createArticleService, updateArticleService, deleteArticleService, fetchArticlesService, approveArticleService, rejectArticleService } from '../../services/ArticleService';
import { fetchCategoriesService, fetchSubCategoriesService } from '../../services/CategoryService'; // Assuming you have a service to fetch categories
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined, EyeOutlined, CloseOutlined, CheckOutlined, FileAddOutlined } from '@ant-design/icons';
import ArticleForm from '../Forms/ArticleForm'; // Import the new ArticleForm component

import { useNavigate } from 'react-router-dom';
import { render } from '@testing-library/react';
import ArticleTableFilter from '../Filters/ArticleTableFilter';
const { confirm } = Modal;

const ArticleTable = () => {
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingArticle, setEditingArticle] = useState(null);
  const navigate = useNavigate(); // 
  const [loading, setLoading] = useState(true); // Loading state
  const [auth, setAuth] = useState(false); // Loading state
  const [userId, setUserId] = useState(null); // User ID state


  const handleReadMore = (article) => {
    navigate(`/admin/articles/${article.id}/view`, { state: { article } }); // Pass the article object via state
    console.log(`Redirect to article with ID: ${article.id}`);
  };

  useEffect(() => {
    fetchData();
    const auth = localStorage.getItem('authToken') !== null;
    setAuth(auth);
    const id = localStorage.getItem('userId');
    setUserId(id);
  }, []);

  const fetchArticles = async () => {
    const result = await fetchArticlesService();
    setArticles(result);
    setFilteredArticles(result); // <-- to refresh when an article is deleted

  };

  const fetchCategories = async () => {
    const result = await fetchCategoriesService(); // Assuming this fetches the list of categories
    setCategories(result);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [articlesData, categoriesData, subCategoriesData] = await Promise.all([
        fetchArticlesService(),
        fetchCategoriesService(),
        fetchSubCategoriesService()
      ]);

      setArticles(articlesData);
      setFilteredArticles(articlesData);
      setCategories(categoriesData);
      setSubCategories(subCategoriesData);
    } catch (error) {
      message.error('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Are you sure you want to delete this article?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => {
        deleteArticleService(id)
          .then(() => {
            setArticles(prevCategories => prevCategories.filter(cat => cat.id !== id));
            setFilteredArticles(prev => prev.filter(item => item.id !== id));
            message.success('Article deleted successfully');
          })
          .catch(error => {
            message.error('Error deleting article');
          });
      },
      onCancel() {
        console.log('Delete canceled');
      },
    });
  };

  const handleRejectArticle = (id) => {
    confirm({
      title: 'Are you sure you want to reject this article?',
      icon: <CloseOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => {
        rejectArticleService(id)
          .then(() => {
            fetchArticles();
            message.success('Article rejected successfully');
          })
          .catch(error => {
            message.error('Error rejecting article');
          });
      },
      onCancel() {
        console.log('reject canceled');
      },
    });
  };

  const handleApproveArticle = (id) => {
    confirm({
      title: 'Are you sure you want to approve this article?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'info',
      cancelText: 'No',
      onOk: () => {
        approveArticleService(id)
          .then(() => {
            fetchArticles();
            message.success('Article approved successfully');
          })
          .catch(error => {
            message.error('Error approved article');
          });
      },
      onCancel() {
        console.log('action canceled');
      },
    });
  };

  const handleApplyFilters = (filters) => {
    const { titleSearch, categoryFilter, subCategoryFilter, statusFilter, visibilityFilter, dateRange } = filters;

    let filtered = [...articles];

    // Filter by title
    if (titleSearch) {
      filtered = filtered.filter(article =>
        article.title.toLowerCase().includes(titleSearch.toLowerCase())
      );
    }

    // Filter by category
    if (categoryFilter && categoryFilter.length > 0) {
      console.log("Filtre des categories", categoryFilter);
      filtered = filtered.filter(article =>
        article.Category && categoryFilter.includes(article.Category.id)
      );
      console.log("Dacategories", filtered);
    }

    // Filter by subcategory
    if (subCategoryFilter && subCategoryFilter.length > 0) {
      filtered = filtered.filter(article =>
        article.SubCategory && subCategoryFilter.includes(article.SubCategory.id)
      );
    }

    // Filter by status
    if (statusFilter && statusFilter.length > 0) {
      filtered = filtered.filter(article =>
        statusFilter.includes(article.status)
      );
    }

    // Filter by visibility
    if (visibilityFilter && visibilityFilter.length > 0) {
      filtered = filtered.filter(article =>
        visibilityFilter.includes(article.visibility)
      );
    }

    // Filter by date range
    if (dateRange && dateRange[0] && dateRange[1]) {
      const startDate = dateRange[0].startOf('day').valueOf();
      const endDate = dateRange[1].endOf('day').valueOf();

      filtered = filtered.filter(article => {
        const articleDate = new Date(article.createdAt).getTime();
        return articleDate >= startDate && articleDate <= endDate;
      });
    }

    setFilteredArticles(filtered);
  };

  const handleSubmit = async (values) => {
    try {
      if (editingArticle) {
        await updateArticleService(editingArticle.id, values);
        message.success('Article updated successfully');
      } else {
        const articleData = {
          title: values.title,
          url: values.url,
          content: values.content,
          Category: {
            connect: {
              id: parseInt(values.categoryId, 10), // Ensure it's an integer
            },
          },
          ArticleImage:
          {
            create: [{ imageUrl: values.ArticleImage[0]?.url || '' }]
            // Pass the image URL if it exists
          },

        };
        await createArticleService(articleData);
        message.success('Article created successfully');
      }
      setIsModalVisible(false);
      fetchArticles();
    } catch (error) {
      message.error('Error while creating/updating article');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteArticleService(id);
      message.success('Article deleted successfully');
      fetchArticles();
    } catch (error) {
      message.error('Error deleting article');
    }
  };

  const showEditModal = (id) => {
    // setEditingArticle(article);
    //setIsModalVisible(true);

    navigate(`/admin/articles/edit/${id}`);
  };

  const showCreateModal = () => {
    navigate('/admin/articles/new')
    setEditingArticle(null);
    //setIsModalVisible(true);
  };

  const columns = [
    {
      title: 'Image',
      dataIndex: 'coverUrl',
      key: 'coverUrl',
      render: (coverUrl) => {
        const imageUrl = coverUrl && coverUrl != "" ? coverUrl : '/default.jpg';
        return imageUrl ? <img src={imageUrl} alt="Article" style={{ width: '100px' }} /> : 'No Image';
      },
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Author',
      dataIndex: ['User', 'name'], // Nested access to parent name directly
      key: 'authorId',
      render: (parentName) => {
        return parentName ? parentName : 'None'; // If parent name exists, render it; otherwise, show 'None'
      },
    },
    {
      title: 'Visibility',
      dataIndex: 'visibility',
      key: 'visibility',
    },

    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'blue';
        if (status === 'REJECTED') color = 'red';
        else if (status === 'APPROVED') color = 'green';
        else if (status === 'DRAFT') color = 'yellow';

        return (
          <div>
            <Tag color={color} className="cursor-pointer">
              {status}
            </Tag>
          </div>
        );
      },
    },

    {
      title: 'Category',
      dataIndex: ['Category', 'name'],
      key: 'Category',
      render: (categoryName) => categoryName || 'Unknown Category',
    },
    {
      title: 'SubCategory',
      dataIndex: ['SubCategory', 'name'],
      key: 'SubCategory',
      render: (categoryName) => categoryName || 'Unknown SubCategory',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => new Date(text).toLocaleString(),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <>
          <Button type="link" icon={<EyeOutlined />} onClick={() => handleReadMore(record)} />
          {(record.authorId == userId || localStorage.getItem('roleType') === 'ADMIN') && (
            <>
              <Button type="link" icon={<DeleteOutlined />} danger onClick={() => showDeleteConfirm(record.id)} />
              <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record.id)} />

            </>
          )}
          {(localStorage.getItem('roleType') == 'ADMIN' && record.status == "DRAFT") && (
            <>
              <Tooltip title="Approve Article">
                <Button
                  type="link"
                  icon={<CheckOutlined />}
                  onClick={() => handleApproveArticle(record.id)}
                />
              </Tooltip>

              <Tooltip title="Reject Article">
                <Button
                  type="link"
                  icon={<CloseOutlined />}
                  danger
                  onClick={() => handleRejectArticle(record.id)}
                />
              </Tooltip>
            </>

          )}
        </>
      ),
    },
  ];



  return (
    <>
      <ArticleTableFilter
        onApplyFilters={handleApplyFilters}
        categories={categories}
        subCategories={subCategories}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
      <Button 
  type="primary" 
  onClick={showCreateModal} 
  style={{ marginBottom: 16 }} 
  icon={<EditOutlined />}
  size='large'
>
  Create Article
</Button>

        <div>
          {filteredArticles.length} article{filteredArticles.length !== 1 ? 's' : ''} found
        </div>
      </div>



      <Spin spinning={loading}>

        <Table columns={columns} rowKey="id" dataSource={filteredArticles}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} articles`,
          }} />
      </Spin>


      <Modal
        title={editingArticle ? 'Edit Article' : 'Create Article'}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() =>
          document.querySelector('.ant-form').dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
        }
        width="80vw" // Set width to full screen
        style={{ top: 0, padding: 0 }} // Adjust style to remove margin/padding
        bodyStyle={{ height: '80vh', padding: 10 }} // Set height to full screen and remove body padding
      >
        <ArticleForm
          categories={categories}
          initialValues={editingArticle}
          onSubmit={handleSubmit}
        />
      </Modal>
    </>
  );

};

export default ArticleTable;
